
import Link from "next/link";
import React from "react";
import NextImage from 'next/image';
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import PropTypes from 'prop-types'
import { useAuth } from "@/hooks/auth";
import { useRouter } from "next/router";
import { useAppSelector } from "@/lib/redux/store";


export default function NavBar({ links }) {
    const { logout } = useAuth();
    const router = useRouter();
    const store = useAppSelector((state) => state.app);
    const { user } = store;
    return (
        <Navbar expand="lg" id="frontend" className="navbar navbar-expand py-3">
            <Container>
                <Link className="" href="/">
                    <NextImage src="/images/instant-polls-logo-horizontal.jpg" alt="Instant Polls Logo" width={250} height={65} className="d-block mx-auto navbarImg" priority />
                </Link>
                <Navbar.Toggle className="navbar-toggler" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" />
                <Navbar.Collapse className="collapse navbar-collapse" id="navbarSupportedContent">
                    <Nav className="navbar-nav ms-auto">
                        {links && links.length > 0 && links.map((link, index) => (
                            <Nav.Link className="nav-item" key={index}>
                                <Link className="nav-link" href={link.href}>{link.label}</Link>
                            </Nav.Link>
                        ))}
                    </Nav>
                    {user ?
                        <div className="ms-auto">
                            <Button
                                className="btn btn-outline-primary me-2 text-light"
                                onClick={() => {
                                    logout();
                                    router.push('/');
                                }}
                            >
                                Logout
                            </Button>
                        </div> :
                        <div className="ms-auto">
                            <Link className="btn btn-outline-primary me-2" href="/login">Sign In</Link>
                            <Link className="btn btn-primary" href="/register">Register</Link>
                        </div>
                    }
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

NavBar.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
};